import { BucketRange } from '../_types';

/**
 * Expands a list of ranges into a flat array of individual bucket indices.
 *
 * Each range is expanded inclusively. Values outside [0, 99] are ignored.
 *
 * @example
 * rangesToBuckets([{ from: 0, to: 3 }, { from: 10, to: 12 }])
 * @returns
 * [0, 1, 2, 3, 10, 11, 12]
 */
export function rangesToBuckets(ranges: BucketRange[]): number[] {
  const buckets: number[] = [];
  for (const { from, to } of ranges) {
    for (let bucketIndex = from; bucketIndex <= to; bucketIndex++) {
      if (bucketIndex >= 0 && bucketIndex <= 99) buckets.push(bucketIndex);
    }
  }
  return buckets;
}
